import { JetView } from 'webix-jet';
import {
    devConfig, // Development configuration settings
    countries, // List of countries for selection
    profile, // User profile information
    cashDesks, // Cash desk information
    agentList, // List of agents
    walletsList, // List of wallets
} from 'config/config';

/**
 * Class representing the filter view for the management report.
 */
export default class FilterInformeGerencialView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for options
                                },
                            },
                            id: 'Countries',
                            on: {
                                onChange: function (data, obj) {
                                    // Event handler for country selection change
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0 && $$('Type').getValue().length > 0) {
                                        $$('consultDesk').enable(); // Enable button if conditions are met
                                    } else {
                                        $$('consultDesk').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Date picker for selecting date
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month', // Month selection
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: new Date(), // Default value set to current date
                            format: '%M %Y', // Date format
                        },
                        {
                            view: 'radio', // Radio buttons for type selection
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Type label
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 500 || screen.height < 500 ? 90 : 0,
                            options: [
                                { id: 'R', value: _('Totales') }, // Total option
                                { id: 'D', value: _('Detallado') }, // Detailed option
                            ],
                            on: {
                                onChange: function (data, obj) {
                                    // Event handler for type selection change
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0 && $$('Countries').getValue().length > 0) {
                                        $$('consultDesk').enable(); // Enable button if conditions are met
                                    } else {
                                        $$('consultDesk').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: screen == 'small' ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Clear form values
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key shortcut
                    id: 'consultDesk',
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('informeGerencial:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse section
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Clear form values
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key shortcut
                    type: 'form',
                    id: 'consultDesk2',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        this.app.callEvent('informeGerencial:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (devConfig.getCountryReport()) {
                // Check if country report is enabled
                if (screen.width > 600) {
                    $$('consultDesk').enable(); // Enable button for larger screens
                } else {
                    $$('consultDesk2').enable(); // Enable button for smaller screens
                }
            }
        });
    }
}

// FILE DOCUMENTED
